import CriticalIcon from '@assets/images/status-critical.svg?react'
import HighIcon from '@assets/images/status-warning.svg?react'
import MediumIcon from '@assets/images/status-moderate.svg?react'

export const statusTextMap: Record<string, string> = {
    open: 'Open',
    waiting: 'Waiting',
    inprogress: 'In Progress',
}

export const getStatusIcon = (severity: TCaseSeverity) => {
    switch (severity) {
        case 'critical':
            return <CriticalIcon width={16} height={16} />
        case 'high':
            return <HighIcon width={16} height={16} />
        case 'medium':
        case 'low':
        default:
            return <MediumIcon width={16} height={16} />
    }
}
